import React, { Fragment, useState } from "react";
import { Col, Row } from "react-bootstrap";
import moment from "moment";
import { balanceSheetReport } from "../../../services/accounts";
import { exportPDF, exportExcel } from "./exportUtils";

export default function BalanceSheet() {
  const [asOnDate, setAsOnDate] = useState(moment().format("YYYY-MM-DD"));
  const [data, setData]         = useState(null);
  const [loading, setLoading]   = useState(false);

  function handleSearch() {
    setLoading(true);
    const temp = new FormData();
    temp.append("as_on_date", asOnDate);
    if (localStorage.getItem("Role") === "1") {
      temp.append("academy_id", localStorage.getItem("AAcademy") || "");
    }
    balanceSheetReport(temp).then((res) => {
      setLoading(false);
      if (res?.status) setData(res.data);
    });
  }

  function LedgerTable({ title, rows, total }) {
    return (
      <table className="table table-bordered table-sm mb-0">
        <thead style={{ backgroundColor: "#2d4ac6", color: "#fff" }}>
          <tr><th colSpan={2} className="text-center" style={{ color: "#fff" }}>{title}</th></tr>
          <tr><th style={{ color: "#fff" }}>Ledger</th><th className="text-end" style={{ color: "#fff" }}>Amount</th></tr>
        </thead>
        <tbody>
          {rows?.map((row, i) => (
            <tr key={i}>
              <td>{row.ledger_name}</td>
              <td className="text-end">{parseFloat(row.balance).toFixed(2)}</td>
            </tr>
          ))}
          {rows?.length === 0 && <tr><td colSpan={2} className="text-muted text-center">—</td></tr>}
        </tbody>
        <tfoot>
          <tr className="fw-bold">
            <td>Total</td>
            <td className="text-end">{total?.toFixed(2)}</td>
          </tr>
        </tfoot>
      </table>
    );
  }

  return (
    <Fragment>
      <div className="page-header reported-header">
        <div>
          <h2 className="main-content-title tx-24 mg-b-5">Balance Sheet</h2>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a>Accounts</a></li>
            <li className="breadcrumb-item active" aria-current="page">Balance Sheet</li>
          </ol>
        </div>
      </div>

      <div className="content-body">
        <div className="container-fluid">
          <div className="card custom-card mg-b-20">
            <div className="card-body">
              <Row className="row-sm mx-0">
                <Col xxl={4} lg={4} md={4}>
                  <div className="mb-3">
                    <label className="form-label">As on Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={asOnDate}
                      onChange={(e) => setAsOnDate(e.target.value)}
                    />
                  </div>
                </Col>
                <Col xxl={4} lg={4} md={4}>
                  <div className="mb-3">
                    <label className="form-label">&nbsp;</label>
                    <div>
                      <a onClick={handleSearch} className="btn btn-success">
                        {loading ? "Loading..." : "Show"}
                      </a>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>

          {data && (
            <div className="card custom-card mg-b-20">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="mb-0">Balance Sheet as on {moment(data.as_on_date).format("DD MMM YYYY")}</h5>
                  <div>
                    <a onClick={() => {
                      const cols = ["Side", "Ledger", "Amount"];
                      const rows = [
                        ...(data.assets      || []).map((r) => ["Assets",      r.ledger_name, parseFloat(r.balance).toFixed(2)]),
                        ["", "Total Assets", data.total_assets?.toFixed(2)],
                        ...(data.liabilities || []).map((r) => ["Liabilities", r.ledger_name, parseFloat(r.balance).toFixed(2)]),
                        ...(data.capital     || []).map((r) => ["Capital",     r.ledger_name, parseFloat(r.balance).toFixed(2)]),
                        ["", "Liabilities + Capital", data.total_liabilities_capital?.toFixed(2)],
                      ];
                      exportPDF(`Balance Sheet - ${moment(data.as_on_date).format("DD MMM YYYY")}`, cols, rows);
                    }} className="btn btn-danger btn-sm me-2">
                      <i className="fa fa-file-pdf-o me-1" /> PDF
                    </a>
                    <a onClick={() => {
                      const cols = ["Side", "Ledger", "Amount"];
                      const rows = [
                        ...(data.assets      || []).map((r) => ["Assets",      r.ledger_name, parseFloat(r.balance).toFixed(2)]),
                        ["", "Total Assets", data.total_assets?.toFixed(2)],
                        ...(data.liabilities || []).map((r) => ["Liabilities", r.ledger_name, parseFloat(r.balance).toFixed(2)]),
                        ...(data.capital     || []).map((r) => ["Capital",     r.ledger_name, parseFloat(r.balance).toFixed(2)]),
                        ["", "Liabilities + Capital", data.total_liabilities_capital?.toFixed(2)],
                      ];
                      exportExcel(`Balance Sheet - ${moment(data.as_on_date).format("DD MMM YYYY")}`, cols, rows);
                    }} className="btn btn-success btn-sm">
                      <i className="fa fa-file-excel-o me-1" /> Excel
                    </a>
                  </div>
                </div>
                <Row className="row-sm mx-0">
                  <Col lg={6} md={12} className="mb-3">
                    <LedgerTable
                      title="Assets"
                      rows={data.assets}
                      total={data.total_assets}
                                          />
                  </Col>
                  <Col lg={6} md={12} className="mb-3">
                    <LedgerTable
                      title="Liabilities"
                      rows={data.liabilities}
                      total={data.liabilities?.reduce((s, r) => s + parseFloat(r.balance || 0), 0)}
                                          />
                    <div className="mt-3">
                      <LedgerTable
                        title="Capital"
                        rows={data.capital}
                        total={data.capital?.reduce((s, r) => s + parseFloat(r.balance || 0), 0)}
                                              />
                    </div>
                  </Col>
                </Row>

                <Row className="row-sm mx-0 mt-2">
                  <Col lg={6} md={12}>
                    <div className="text-center fw-bold mb-0">
                      Total Assets: ₹{data.total_assets?.toFixed(2)}
                    </div>
                  </Col>
                  <Col lg={6} md={12}>
                    <div className="text-center fw-bold mb-0">
                      Liabilities + Capital: ₹{data.total_liabilities_capital?.toFixed(2)}
                    </div>
                  </Col>
                </Row>
                <div className="text-center fw-bold mt-3">
                  {Math.abs(data.total_assets - data.total_liabilities_capital) < 0.01
                    ? <><i className="fa fa-check-circle me-1 text-success" /> Balance Sheet is Balanced</>
                    : <><i className="fa fa-exclamation-circle me-1" /> Difference: ₹{Math.abs(data.total_assets - data.total_liabilities_capital).toFixed(2)}</>
                  }
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
}
